import axios from 'axios'
import { checkId } from './utils'
import prepareUrl from '@/utils/prepareUrl'
export default function makeServiceActions (apiUrl) {
  function removeDuplicatedShifts (exams) {
    if (Array.isArray(exams)) {
      exams.forEach(exam => {
        if (exam && exam.shifts && exam.shifts.length) {
          exam.shifts = exam.shifts.filter((shift, index, self) =>
            index === self.findIndex((s) => (
              s.guid === shift.guid
            ))
          )
        }
      })
    }
  }
  const serviceActions = {
    async find (context, { params, query, options } = {}) {
      const { state, commit, dispatch } = context
      if (state.canceller) {
        await state.canceller('cancel')
        commit('unsetCanceller')
      }
      const url = prepareUrl(`${apiUrl}`, params, query, options)
      commit('setFindPending')
      commit('setFindPending', null, { root: true })
      commit('setResponseError', null, { root: true })
      return new Promise((resolve, reject) => {
        axios({
          url,
          cancelToken: new axios.CancelToken(function (canceller) {
            commit('setCanceller', canceller)
          })
        }).then((response) => {
          if (response instanceof axios.Cancel) {
            return resolve(response)
          }
          response = response && response.data
          removeDuplicatedShifts(response.data)

          if (options && options.isUniqKey) {
            response.data = response.data.map((item, index) => Object.assign(item, { 'uniq_guid_key': `${item.guid}-${index}` }))
          }

          commit('unsetCanceller')
          commit('setData', response && response.data)
          dispatch('addOrUpdateList', response)
          if (response && response.error) {
            reject(response && response.error)
          }

          if (response.meta) {
            commit('updatePaginationForQuery', response && response.meta)
          }

          resolve(response && response.data)
          commit('unsetFindPending')
          commit('unsetFindPending', null, { root: true })
        }).catch(response => {
          const error = response && response.data && response.data.error
          if (error) {
            commit('setFindError', error)
          }
          reject(error)
          commit('unsetFindPending')
          commit('unsetFindPending', null, { root: true })
        })
      })
    },
    get ({ state, commit, dispatch, rootState }, args) {
      let id
      let url
      if (Array.isArray(args)) {
        id = args[0]
        url = prepareUrl(`${apiUrl}`, args[1], args[2])
      } else {
        id = args
        url = prepareUrl(`${apiUrl}`, { id })
      }
      url = `${url.replace(/\?.*/, '')}/${id ? `${id}` : ''}`
      commit('setGetPending')
      return new Promise((resolve, reject) => {
        axios({ url }).then(response => response.data)
          .then((response) => {
            if (response && response.error) {
              reject(response.error)
            }
            // commit('setData', response && response.data)

            const item = response.data
            // const id = item[idField]

            dispatch('addOrUpdate', item)
            commit('setCurrent', item)
            commit('unsetGetPending')

            resolve(item)
          })
          .catch(({ data: { error } }) => {
            commit('setGetError', error)
            reject(error)
          })
          .finally(() => {
            commit('unsetGetPending')
          })
      })
    },
    create ({ commit, dispatch, state, rootState }, dataOrArray) {
      const { idField } = state
      let data
      let query
      // let params
      if (Array.isArray(dataOrArray)) {
        data = dataOrArray[0]
        query = dataOrArray[1]
      } else {
        data = dataOrArray
      }
      const url = `${apiUrl.replace(/\?.*/, '')}${query ? `${query}` : ''}`
      commit('setCreatePending')
      return new Promise((resolve, reject) => {
        axios({ url, method: 'post', data }).then(response => response.data)
          .then(({ error, data }) => {
            if (error) {
              reject(error)
            }
            if (Array.isArray(data)) {
              dispatch('addOrUpdateList', data)
            } else {
              const id = data[idField]
              dispatch('addOrUpdate', data)
              if (state.setCurrentOnCreate) {
                commit('setCurrent', data)
              }
              if (state.keyedById[id]) {
                data = state.keyedById[id]
              }
            }
            resolve(data)
          })
          .catch((error) => {
            console.log(error)
            commit('setCreateError', error)
            reject(error)
          })
          .finally(() => {
            commit('unsetCreatePending')
          })
      })
    },
    update ({ commit, dispatch, state, rootState }, dataOrArray) {
      let data
      let id
      let query
      if (Array.isArray(dataOrArray)) {
        id = dataOrArray[0]
        data = dataOrArray[1]
        query = dataOrArray[2]
      } else {
        data = dataOrArray
      }
      const url = `${apiUrl.replace(/\?.*/, '')}${id ? `/${id}` : ''}${query ? `${query}` : ''}`
      commit('setUpdatePending')
      return new Promise((resolve, reject) => {
        axios({ url, method: 'put', data }).then(response => response.data)
          .then(({ error, data }) => {
            if (error) {
              reject(error)
            }
            dispatch('addOrUpdate', data || [])
            resolve(data)
          })
          .catch(response => {
            const error = response && response.data && response.data.error
            commit('setUpdateError', error)
            commit('setResponseError', error, { root: true })
            reject(error)
          })
          .finally(() => {
            commit('unsetUpdatePending')
          })
      })
    },
    remove  ({ commit, dispatch, rootState }, idOrArray) {
      let id
      let data
      let query
      if (Array.isArray(idOrArray)) {
        id = idOrArray[0]
        data = idOrArray[1]
        query = idOrArray[2]
      } else {
        id = idOrArray
      }
      const url = `${apiUrl.replace(/\?.*/, '')}${id ? `/${id}` : ''}${query ? `${query}` : ''}`
      commit('setRemovePending')
      return new Promise((resolve, reject) => {
        axios({ url, method: 'delete', data }).then(response => response.data)
          .then(({ error, data }) => {
            commit('unsetRemovePending')
            if (error) {
              reject(error)
            }
            commit('removeItem', id)
            commit('unsetRemovePending')
            resolve(data)
          })
          .catch(response => {
            const error = response && response.data && response.data.error
            commit('setRemoveError', error)
            reject(error)
          })
          .finally(() => {
            commit('unsetRemovePending')
          })
      })
    }
  }
  const actions = {
    addOrUpdateList ({ state, commit }, response) {
      const list = response.data || response
      const isPaginated = response.meta && response.meta.hasOwnProperty('total')
      const toAdd = []
      const toUpdate = []
      const toRemove = []
      const { idField, autoRemove } = state

      if (Array.isArray(list)) {
        list.forEach((item) => {
          let id = item[idField]
          let existingItem = state.keyedById[id]
          const isIdOk = checkId(id, item)
          if (isIdOk) {
            existingItem ? toUpdate.push(item) : toAdd.push(item)
          }
        })
        if (!isPaginated && autoRemove) {
          // Find IDs from the state which are not in the list
          state.ids.forEach(id => {
            if (id !== state.currentId && !list.some(item => item[idField] === id)) {
              toRemove.push(state.keyedById[id])
            }
          })
          commit('removeItems', toRemove) // commit removal
        }
        commit('addItems', toAdd)
        commit('updateItems', toUpdate)
      }
    },
    addOrUpdate ({ state, commit }, item) {
      const { idField } = state
      let id = item[idField]
      let existingItem = state.keyedById[id]
      const isIdOk = checkId(id, item)
      if (isIdOk) {
        existingItem ? commit('updateItem', item) : commit('addItem', item)
      }
    }
  }
  Object.keys(serviceActions).map(method => {
    if (serviceActions[method] && typeof serviceActions[method] === 'function') {
      actions[method] = serviceActions[method]
    }
  })
  return actions
}
